import { Button, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { PageBody, PageHeader } from "../common";

const LandingspageRegistration = () => {
  const navigate = useNavigate();
  const navigateToCreate = () => navigate("create");
  const navigateToChange = () => navigate("change");
  const navigateToCancel = () => navigate("cancel");

  return (
    <>
      <PageHeader maxWidth="sm" title="registrationTitle" />
      <PageBody maxWidth="sm">
        <Stack spacing={1}>
          <Typography variant="body2">
            <FormattedMessage id="landingRegister"></FormattedMessage>
          </Typography>
          <Button onClick={navigateToCreate} variant="outlined" fullWidth>
            <FormattedMessage id="registerCreate" />
          </Button>
          <Button onClick={navigateToChange} variant="outlined" fullWidth>
            <FormattedMessage id="changeRegistrationTitle" />
          </Button>
          <Button onClick={navigateToCancel} variant="outlined" fullWidth>
            <FormattedMessage id="cancelRegistrationTitle" />
          </Button>
        </Stack>
      </PageBody>
    </>
  );
};

export default LandingspageRegistration;
